import { MainLayout } from "@/components/MainLayout";
import { SEO } from "@/components/SEO";

export default function InvoicesPage() {
  return (
    <MainLayout>
      <SEO 
        title="Notas fiscais de serviço"
        description="Gerencie notas fiscais de serviço"
        keywords="notas fiscais, serviços"
      />
      <div className="section-delimited">
        <h1 className="text-2xl font-bold mb-4">Notas fiscais de serviço</h1>
        <p className="text-muted-foreground">Página em desenvolvimento</p>
      </div>
    </MainLayout>
  );
}

